export default __webpack_public_path__ + "static/returns-9e426030d0d07d047cdb6b74f71449b6.jpg";